/**
 * CanvasOptionsContext — view-state shared across the canvas + custom edges.
 *
 * Currently carries the `showLabels` toggle (driven by the Labels button in
 * SessionTopbar). KaivaEdge subscribes via `useCanvasOptions()` to know
 * whether to render the relationship pill. New canvas-wide preferences
 * (focus mode, density, etc.) can be added here as future phases land.
 */

import { createContext, useContext, useMemo, type ReactNode } from 'react';

interface CanvasOptions {
  showLabels: boolean;
}

const DEFAULT: CanvasOptions = {
  showLabels: true,
};

const CanvasOptionsCtx = createContext<CanvasOptions>(DEFAULT);

export function CanvasOptionsProvider({
  showLabels,
  children,
}: {
  showLabels: boolean;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ showLabels }), [showLabels]);
  return <CanvasOptionsCtx.Provider value={value}>{children}</CanvasOptionsCtx.Provider>;
}

export function useCanvasOptions(): CanvasOptions {
  return useContext(CanvasOptionsCtx);
}
